import { Image, Text } from '@ui/atoms';
import React from 'react';

const WhyBondsWithJiraaf = () => {
    const whyBondsData = {
        title: 'Why buy Bonds with Jiraaf?',
        description:
            'Because stability isn’t just in our returns,<br class="hidden md:inline-block"/> it’s in everything we do',
        rows: [
            [
                {
                    title: 'Curated with care, built for confidence',
                    description: 'Risk-assessed fixed-income opportunities',
                    image: '/images/homepage/favorite-chart.svg',
                    alt: 'chart',
                },
                {
                    title: 'Real support, not just bots',
                    description: 'Dedicated relationship manager',
                    image: '/images/homepage/message-favorite.svg',
                    alt: 'message',
                },
            ],
            [
                {
                    title: 'We’ve seen it all, so you don’t have to',
                    description: 'Expert team with 100+ years of experience',
                    image: '/images/homepage/medal-star.svg',
                    alt: 'medal-star',
                },
                {
                    title: 'Total transparency',
                    description: 'Easy access to every detail that matters',
                    image: '/images/homepage/eye-frame.svg',
                    alt: 'eye',
                },
            ],
        ],
    };

    return (
        <div className="relative bg-[url('/images/homepage/why-bonds-bg.svg')] xl:bg-[length:130%] bg-[center_50%] xl:bg-[center_10%] bg-no-repeat">
            <div className="flex flex-col items-center gap-10 md:px-6 xl:px-16 px-4 py-12 md:py-18">
                <div className="flex flex-col gap-2 md:gap-3 items-center md:max-w-[959px]">
                    <Text
                        content={whyBondsData.title}
                        className="h5-medium md:h4-semibold text-secondary-500"
                    />
                    <Text
                        content={whyBondsData.description}
                        className="h5-semibold md:h2-semibold text-basicWhite text-center"
                        isInnerHtml
                    />
                </div>
                <div className="flex flex-col gap-10 md:gap-[72px] items-center max-w-[900px] w-full">
                    {whyBondsData.rows.map((row, rowIndex) => (
                        <div
                            key={rowIndex}
                            className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-6 justify-center w-full"
                        >
                            {row.map((section, sectionIndex) => (
                                <div
                                    key={sectionIndex}
                                    className="flex md:flex-col md:items-center gap-3 w-full"
                                >
                                    <Image
                                        src={section.image}
                                        className="w-10 h-10 md:w-12 md:h-12 p-2 rounded-xl bg-basicWhite/10"
                                        alt={section.alt}
                                    />
                                    <div className="flex flex-col gap-1 md:items-center">
                                        <Text
                                            content={section.title}
                                            className="h7-medium md:h6-semibold text-basicWhite md:text-center"
                                        />
                                        <Text
                                            content={section.description}
                                            className="p5-regular md:p4-regular text-basicWhite md:text-center"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WhyBondsWithJiraaf;
